// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"styles_videoContainer__3m6N7","skipBtn":"styles_skipBtn__2Vz_n"};